import { CSSProperties, useEffect, useState } from "react";
import classNames from "classnames";

import Input from "components/Input";

import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

// Pole koloru: próbnik (natywne pole type="color" otwiera systemowy wybór koloru — w repo ani w MUI nie ma innego wyboru
// koloru) i zapis szesnastkowy w zwykłym polu Input obok. Na zewnątrz wychodzi zawsze #RRGGBB wielkimi literami; niepełny
// albo błędny zapis w polu tekstowym nie zmienia wartości, a po opuszczeniu pola wraca do niej.

const HEX = /^#?([0-9a-f]{6})$/i;

/** `#RRGGBB` wielkimi literami albo `null`, gdy tekst nie jest pełnym kolorem. */
const normalizeHex = (value: string): string | null => {
  const match = HEX.exec(value.trim());
  return match ? `#${match[1].toUpperCase()}` : null;
};

const ColorField: FC<Props> = ({ label, value, onChange, disabled = false, className }) => {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  const handleText = (next: string) => {
    setText(next);
    const hex = normalizeHex(next);

    if (hex && hex !== value) onChange(hex);
  };

  return (
    <div className={classNames(styles.wrapper, className)}>
      <label
        className={classNames(styles.swatch, disabled && styles.swatchDisabled)}
        // arch-ignore inline-styl -- kolor próbnika to wartość pola: zmienna CSS, tło ustawia arkusz
        style={{ "--swatch-color": value } as CSSProperties}
        title={value}
      >
        <input
          type="color"
          className={styles.native}
          // przeglądarka trzyma wartość małymi literami — wielkie litery wymuszałyby przepisanie przy każdym renderze
          value={value.toLowerCase()}
          disabled={disabled}
          aria-label={label}
          onChange={(e) => handleText(e.target.value)}
        />
      </label>
      <div className={styles.input}>
        <Input
          label={label}
          value={text}
          onChange={handleText}
          onBlur={() => setText(value)}
          disabled={disabled}
          inputProps={{ maxLength: 7, spellCheck: false }}
        />
      </div>
    </div>
  );
};

export default ColorField;
